// https://stackoverflow.com/a/50901817/2698227
const randomString = (): string => {
  return btoa(Math.random().toString()).substr(10, 5)
}

export { randomString }
